import React, { useEffect, useState } from "react";
import { Phone, X } from "lucide-react";
import { api } from "@/lib/api";

const DEFAULT_MESSAGE = "Contact on these numbers for booking your Ad. Currently only Public Notice (for Advocates) bookings are available through this site. Other ad categories coming soon.";

export default function ComingSoonModal({
  open,
  onClose,
  adTypeLabel,
  message,
  badge = "Coming Soon",
}) {
  const [phones, setPhones] = useState([]);
  useEffect(() => {
    if (open) {
      api.get("/company/phones")
        .then(({ data }) => setPhones(data.phones || []))
        .catch((err) => console.warn("[ComingSoonModal] Failed to load phones:", err));
    }
  }, [open]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-navy-deep/60 backdrop-blur-sm p-4 animate-fade-up"
         onClick={onClose}
         data-testid="coming-soon-modal">
      <div
        className="bg-white max-w-lg w-full rounded-sm border border-slate-200 shadow-card-hover overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-7 pt-7 pb-2 flex items-start justify-between">
          <div>
            <div className="text-[10px] tracking-overline uppercase text-gold font-bold">{badge}</div>
            <h3 className="font-display text-3xl text-navy-deep mt-1">{adTypeLabel || "Other Ad Categories"}</h3>
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-navy" data-testid="coming-soon-close">
            <X size={22}/>
          </button>
        </div>
        <div className="px-7 pb-2">
          <p className="text-slate-700 leading-relaxed">
            {message || DEFAULT_MESSAGE}
          </p>
        </div>
        <div className="px-7 py-5 grid grid-cols-2 gap-3 bg-parchment border-t border-slate-200">
          {(phones.length ? phones : ["+91 77220 74451","+91 97623 83215","+91 98906 28251"]).map((p, idx) => (
            <a
              key={p}
              href={`tel:${p.replace(/\s+/g,"")}`}
              className="flex items-center gap-2 text-navy-deep hover:text-gold transition font-mono text-sm"
              data-testid={`coming-soon-phone-${idx}`}
            >
              <Phone size={14}/> {p}
            </a>
          ))}
        </div>
        <div className="px-7 py-4 bg-white border-t border-slate-200 flex justify-end">
          <button
            onClick={onClose}
            className="px-5 py-2 bg-navy text-parchment hover:bg-gold rounded-sm text-sm transition"
            data-testid="coming-soon-ok"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
